import React from 'react';
import { ToastContainer } from './styles';

interface WrappedToastContainerProps {
  className?: string;
  autoClose?: number;
}

const WrappedToastContainer: React.FC<WrappedToastContainerProps> = ({
  className,
  ...rest
}: WrappedToastContainerProps) => {
  return (
    <div className={className}>
      <ToastContainer {...rest} icon={false} />
    </div>
  );
};

export default WrappedToastContainer;
